module.exports = __webpack_public_path__ + "img/Recubre_Pulido Blanco.9036ca24.png";